import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { trackActivity } from '@/lib/productActivity';

const GA_MEASUREMENT_ID = 'G-4EMLK23MFF';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4 on first mount
    if (!ReactGA.isInitialized) {
      ReactGA.initialize(GA_MEASUREMENT_ID, {
        gaOptions: {
          debug_mode: import.meta.env.DEV,
        },
      });
    }
  }, []);

  useEffect(() => {
    // Track page views on route change
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
    // Product activity feed (super-admin): path only, never the query string.
    trackActivity('page_view', { path: location.pathname });
  }, [location]);
};
